//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/ScCollector.js";
import "../no/RegionPointList.js";
import "../no/SelectBody.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"AsPatchSurface",1,0],[0,"BodyColor",1,0],[1,"BoundaryBody",0,"SelectNXObjectList",0],[0,"BoundaryType",1,0],[0,"ConvertType",1,0],[1,"LoopCollector",0,"ScCollector",0],[1,"RegionPoint",0,"RegionPointList",0],[0,"RegionType",1,0],[1,"TargetBody",0,"SelectBody",0]],[[["redValue","greenValue","blueValue"],"GetColorValue",{},0,0],[["redValue","greenValue","blueValue"],"SetColorValue",{},3,0],[["traverseEdges"],"SetTraverseEdges",{},1,0],[[],"GetNewCavityAndCorePartingProcessStatus",{R_:{newCavityAndCorePartingProcessStatus:''}},0,0]],[]];
SPLM.Tooling.TrimRegionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.TrimRegionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.TrimRegionBuilder.BoundaryOption = Object.freeze({
    "BodyCurve" : "BodyCurve", "Traverse" : "Traverse"});

SPLM.Tooling.TrimRegionBuilder.RegionOption = Object.freeze({
    "Keep" : "Keep", "Discard" : "Discard"});

SPLM.Tooling.TrimRegionBuilder.ConvertTypeOption = Object.freeze({
    "WithCopies" : "WithCopies", "NoCopies" : "NoCopies"});

export default SPLM;